export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Author: ['App', 'User'],
    CaseSummary: ['Case', 'CaseBrief'],
    Document: [
      'CaseDocument',
      'CustomerDocument',
      'FinancialAccountDocument',
      'OrderDocument',
      'TicketDocument',
    ],
    FinancialAccountTicket: ['MediationTicket', 'NegotiationTicket'],
    Node: [
      'App',
      'AppToken',
      'BusinessEntity',
      'Campaign',
      'CampaignResolver',
      'Case',
      'CaseAction',
      'CaseActionResult',
      'CaseActionType',
      'CaseCloseReason',
      'CaseDocument',
      'CaseEvent',
      'CaseImportQuarantine',
      'CaseProduct',
      'CaseProductFinancialAccount',
      'CaseReminder',
      'CaseTag',
      'CaseType',
      'CountryArea',
      'Customer',
      'CustomerAddress',
      'CustomerContactEmail',
      'CustomerContactPhone',
      'CustomerDocument',
      'CustomerEvent',
      'FinancialAccount',
      'FinancialAccountDocument',
      'FinancialAccountType',
      'FinancialProvider',
      'FinancialProviderContact',
      'MediationTicket',
      'MessagingQuickReply',
      'NegotiationTicket',
      'Order',
      'OrderDocument',
      'OrderDocumentEsignRequest',
      'OrderDocumentType',
      'OrderEvent',
      'OrderFinancialAccount',
      'OrderPayment',
      'Product',
      'ProductPackage',
      'ProductPackageOrderLine',
      'ProductPackageStateDependencies',
      'ProductPackageStateEffects',
      'Regency',
      'TicketAction',
      'TicketActionResult',
      'TicketActionType',
      'TicketCloseReason',
      'TicketDocument',
      'TicketEvent',
      'TicketTag',
      'User',
      'UserTeam',
    ],
    NodeUpdatedEvent: [
      'CaseUpdatedEventModel',
      'OrderDocumentUpdatedEventModel',
      'OrderUpdatedEventModel',
    ],
    OrderStateProgressBlocker: [
      'OrderStateProgressBlockerCaseDocumentType',
      'OrderStateProgressBlockerCaseIdentityCheck',
      'OrderStateProgressBlockerCustomerDocumentType',
      'OrderStateProgressBlockerFinancialAccountDocumentType',
      'OrderStateProgressBlockerGenerateDocumentType',
      'OrderStateProgressBlockerOrderDocumentType',
      'OrderStateProgressBlockerOrderPaymentStatus',
      'OrderStateProgressBlockerValidationEntity',
    ],
    Ticket: ['MediationTicket', 'NegotiationTicket'],
  },
}
export default result
